/* src/app/views/display/components/display-section/display-menu-section/display-menu-section-body/display-menu-section-options/display-menu-section-options-container/display-menu-section-options-container.component.scss */
:host {
  display: contents;
}
/*# sourceMappingURL=display-menu-section-options-container.component.css.map */
